export default __webpack_public_path__ + "static/media/facebook-icon.d45382dc.svg";